"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _Alert = _interopRequireDefault(require("../Alert"));
var _ToastContext = _interopRequireWildcard(require("./ToastContext"));
var _UIElementStatusEnum = require("../../ts/enums/UIElementStatusEnum");
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function useNotify() {
  const {
    addToast,
    removeToast
  } = (0, _ToastContext.useToast)();
  const convertKeysToLowerCase = (0, _react.useCallback)(obj => {
    var _Object$entries;
    return Object.fromEntries(Object === null || Object === void 0 || (_Object$entries = Object.entries(obj || {})) === null || _Object$entries === void 0 ? void 0 : _Object$entries.map(_ref => {
      let [key, value] = _ref;
      return [key.toLowerCase(), value];
    }));
  }, []);
  const notify = {
    success: data => {
      const {
        title,
        description,
        time
      } = convertKeysToLowerCase(data);
      addToast({
        type: _UIElementStatusEnum.UIElementStatusEnum.Success,
        title,
        description,
        time
      });
    },
    error: data => {
      const {
        title,
        description,
        time
      } = convertKeysToLowerCase(data);
      addToast({
        type: _UIElementStatusEnum.UIElementStatusEnum.Error,
        title,
        description,
        time
      });
    },
    info: data => {
      const {
        title,
        description,
        time
      } = convertKeysToLowerCase(data);
      addToast({
        type: _UIElementStatusEnum.UIElementStatusEnum.Info,
        title,
        description,
        time
      });
    },
    warning: data => {
      const {
        title,
        description,
        time
      } = convertKeysToLowerCase(data);
      addToast({
        type: _UIElementStatusEnum.UIElementStatusEnum.Warning,
        title,
        description,
        time
      });
    },
    default: data => {
      const {
        title,
        description,
        time
      } = convertKeysToLowerCase(data);
      addToast({
        type: _UIElementStatusEnum.UIElementStatusEnum.Info,
        title,
        description,
        time
      });
    },
    remove: id => {
      removeToast(id);
    }
  };
  return notify;
}
function Toast(_ref2) {
  let {
    toasts,
    options
  } = _ref2;
  if (!(toasts !== null && toasts !== void 0 && toasts.length)) return null;
  const limitedToasts = (0, _react.useMemo)(() => (toasts === null || toasts === void 0 ? void 0 : toasts.slice(0, 10)) || [], [toasts]);
  return limitedToasts === null || limitedToasts === void 0 ? void 0 : limitedToasts.map((_ref3, index) => {
    let {
      id,
      title,
      description,
      type
    } = _ref3;
    return /*#__PURE__*/_react.default.createElement(Container, {
      key: id,
      index: index,
      options: options
    }, /*#__PURE__*/_react.default.createElement(_Alert.default, {
      show: true,
      type: type,
      title: title,
      description: description,
      outlined: false
    }));
  });
}
const _ALERT_HEIGHT = 50;
const Container = _styled.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  left: 30px;\n  right: -10px;\n  z-index: 100;\n  top: ", "px;\n"])), _ref4 => {
  let {
    index,
    options
  } = _ref4;
  return index * (_ALERT_HEIGHT + 15) + (options === null || options === void 0 ? void 0 : options.firstToastSpace);
});
Toast.Provider = _ToastContext.default;
Toast.useNotify = useNotify;
var _default = exports.default = Toast;